import { Flex } from "antd";
import { CommonTable } from "components";
import { observer } from "mobx-react-lite";
import { useLocation, useNavigate } from "react-router-dom";
import { useStores } from "stores";

import { routes } from "constants/routes";
import { getCompaniesColumns } from "widgets";

export const PendingActionsCompanies = observer(() => {
  const { pendingActionsCompanyList } = useStores();
  const navigate = useNavigate();

  return (
    <Flex vertical gap="large" className="margin-top-md">
      <CommonTable
        store={pendingActionsCompanyList}
        updateWithInterval
        columns={getCompaniesColumns({ companies: pendingActionsCompanyList, showFiltersToStatuses: false })}
        onRow={(record) => ({
          onClick: () => navigate(`/${routes.companies}/${record.id}`),
          className: "cursor-pointer",
        })}
        whiteBox
        widgets={{
          search: true,
          date: true,
        }}
      />
    </Flex>
  );
});
